export const createChatMessage = ({
  from,
  payload,
  getMessageId,
  getTime,
}) => {
  return {
    id: getMessageId(),
    from,
    time: getTime(),
    ...payload,
  }
}

export const appendChatMessage = ({
  messages,
  from,
  payload,
  getMessageId,
  getTime,
}) => {
  const newMessage = createChatMessage({
    from,
    payload,
    getMessageId,
    getTime,
  })

  return [...messages, newMessage]
}

export const addLoadingMessage = ({
  messages,
  loadingMessageId,
  getTime,
}) => {
  return [
    ...messages,
    {
      id: loadingMessageId,
      from: 'ai',
      productsLoading: true,
      time: getTime(),
    },
  ]
}

export const removeMessageById = ({
  messages,
  messageId,
}) => {
  return messages.filter((message) => message.id !== messageId)
}